import L from 'leaflet'

import red from 'attachments/red_point.png'
import lila from 'attachments/lila_point.png'
import orange from 'attachments/orange_point.png'
import blue from 'attachments/blue_point.png'
import yellow from 'attachments/yellow_point.png'
import green from 'attachments/green_point.png'
import purple from 'attachments/purple_point.png'
import brujxs from 'attachments/brujxs_point.png'

const icon = ( color = 'red' ) => {
  let p = red

  switch( color ) {
    case 'lila':
      p = lila
      break
    case 'blue':
      p = blue
      break
    case 'orange':
      p = orange
      break
    case 'yellow':
      p = yellow
      break
    case 'green':
      p = green
      break
    case 'purple':
      p = purple
      break
    case 'brujxs':
      p = brujxs
      break
  }

  return L.icon( {
    iconUrl: p,
    iconSize: [ 20, 20 ],
  } )

}

export default icon
